import { getDefault } from '@cleartax/wg-library-utils';
import get from 'lodash.get';
import {
  ICompanyData,
  IOrder,
  IPriceData,
  IProductData,
} from '../types/checkout.types';

export const priceApiTransformer = (data: Partial<IPriceData>): IPriceData => {
  return {
    taxInfo: {
      tax: get(data, 'taxInfo.tax', ''),
      cgst: get(data, 'taxInfo.cgst', ''),
      sgst: get(data, 'taxInfo.sgst', ''),
      igst: get(data, 'taxInfo.igst', ''),
    },
    discount: get(data, 'discount', ''),
    referralCoupon: get(data, 'referralCoupon', false),
    couponDiscountType: get(data, 'couponDiscountType', ''),
    amountSymbol: get(data, 'amountSymbol', '₹'),
    couponDiscountValue: get(data, 'couponDiscountValue', ''),
    originalPrice: get(data, 'originalPrice', ''),
    grossPrice: get(data, 'grossPrice', ''),
    grossPriceWithoutTax: get(data, 'grossPriceWithoutTax', ''),
    roundedAmount: get(data, 'roundedAmount', ''),
    roundedTax: get(data, 'roundedTax', ''),
    offerPricing: {
      originalPrice: get(data, 'offerPricing.originalPrice', ''),
      discountPercentage: get(data, 'offerPricing.discountPercentage', ''),
    },
    couponCode: get(data, 'couponCode', ''),
    appliedDiscount: get(data, 'appliedDiscount', ''),
    couponDiscount: get(data, 'couponDiscount', ''),
    discountedPrice: get(data, 'discountedPrice', ''),
    totalAmount: get(data, 'totalAmount', ''),
    listPrice: get(data, 'listPrice', ''),
    couponError: get(data, 'couponError', ''),
    priceBreakup: get(data, 'priceBreakup', []),
    taxableDiscountTaxBreakup: get(data, 'taxableDiscountTaxBreakup', []),
    nonTaxableDiscountTaxBreakup: get(data, 'nonTaxableDiscountTaxBreakup', []),
    totalAmountToBePaid: get(data, 'totalAmountToBePaid', ''),
    amountPaid: get(data, 'amountPaid', ''),
  };
};

export const productDataTransformer = (
  data: Partial<IProductData>
): IProductData => {
  return {
    name: get(data, 'name', ''),
    planId: get(data, 'planId', ''),
    sku: get(data, 'sku', ''),
    gstIn: get(data, 'gstIn', ''),
    countryCode: get(data, 'countryCode', ''),
    dialCode: get(data, 'dialCode', ''),
    productServiceType: get(data, 'productServiceType', ''),
    isPayable: get(data, 'isPayable', true),
  };
};

export const orderDataTransformer = (data: Partial<IOrder>): IOrder => {
  const a = {
    razorKey: getDefault(data, 'razorKey', ''),
    orderID: getDefault(data, 'orderID', ''),
    paymentGateway: getDefault(data, 'paymentGateway', ''),
    amt: getDefault(data, 'amt', ''),
    txnId: getDefault(data, 'txnId', ''),
    notes: getDefault(data, 'notes', ''),
    razorpayOrderID: getDefault(data, 'razorpayOrderID', ''),
    juspayOrderID: getDefault(data, 'juspayOrderID', ''),
    paymentURL: getDefault(data, 'paymentURL', ''),
    redirectionURL: getDefault(data, 'redirectionURL', ''),
    productServiceType: getDefault(data, 'productServiceType', ''),
  };
  return a;
};

export const companyDataTransformer = (
  data: Partial<ICompanyData>
): ICompanyData => {
  return {
    taxpayerInfo: {
      gstin: get(data, 'taxpayerInfo.gstin', ''),
      lgnm: get(data, 'taxpayerInfo.lgnm', ''),
      stj: get(data, 'taxpayerInfo.stj', ''),
      ctj: get(data, 'taxpayerInfo.ctj', ''),
      rgdt: get(data, 'taxpayerInfo.rgdt', ''),
      ctb: get(data, 'taxpayerInfo.ctb', ''),
      dty: get(data, 'taxpayerInfo.dty', ''),
      nba: get(data, 'taxpayerInfo.nba', ''),
      sts: get(data, 'taxpayerInfo.sts', ''),
      cxdt: get(data, 'taxpayerInfo.cxdt', ''),
      tradeNam: get(data, 'taxpayerInfo.tradeNam', ''),
      stjCd: get(data, 'taxpayerInfo.stjCd', ''),
      ctjCd: get(data, 'taxpayerInfo.ctjCd', ''),
      pradr: {
        addr: {
          bnm: get(data, 'taxpayerInfo.pradr.addr.bnm', ''),
          st: get(data, 'taxpayerInfo.pradr.addr.st', ''),
          loc: get(data, 'taxpayerInfo.pradr.addr.loc', ''),
          bno: get(data, 'taxpayerInfo.pradr.addr.bno', ''),
          stcd: get(data, 'taxpayerInfo.pradr.addr.stcd', ''),
          flno: get(data, 'taxpayerInfo.pradr.addr.flno', ''),
          lt: get(data, 'taxpayerInfo.pradr.addr.lt', ''),
          lg: get(data, 'taxpayerInfo.pradr.addr.lg', ''),
          dst: get(data, 'taxpayerInfo.pradr.addr.dst', ''),
          city: get(data, 'taxpayerInfo.pradr.addr.city', ''),
          pncd: get(data, 'taxpayerInfo.pradr.addr.pncd', ''),
        },
        ntr: get(data, 'taxpayerInfo.pradr.ntr', ''),
      },
      adadr: get(data, 'taxpayerInfo.adadr', ''),
      frequencyType: get(data, 'taxpayerInfo.frequencyType', ''),
      lstupdt: get(data, 'taxpayerInfo.lstupdt', ''),
      errorMsg: get(data, 'taxpayerInfo.errorMsg', ''),
    },
  };
};
